import { useMutation } from '@tanstack/react-query'
import { resetPassword } from '../index'

const useResetPassword = () =>
  useMutation({
    mutationFn: resetPassword,
  })

export default useResetPassword
